export default "__VITE_ASSET__CkA9W8Gm__"